export const CERTY_URL = 'https://certy.es';
export const CERTY_ORGANIZATION_ID = `${CERTY_URL}/#organization`;
export const CERTY_WEBSITE_ID = `${CERTY_URL}/#website`;
export const CERTY_SOFTWARE_ID = `${CERTY_URL}/#software`;

export const certyOrganizationSchema = {
  '@type': 'Organization',
  '@id': CERTY_ORGANIZATION_ID,
  name: 'Certy',
  url: `${CERTY_URL}/`,
  logo: {
    '@type': 'ImageObject',
    url: `${CERTY_URL}/certy-logo-512.png`,
    width: 512,
    height: 512
  },
  email: 'contacto@certy.es',
  description:
    'Certy desarrolla software de escritorio para localizar, organizar y controlar certificados digitales instalados en equipos Windows.',
  knowsAbout: [
    'certificados digitales',
    'almacén de certificados de Windows',
    'caducidad de certificados',
    'portales de la Administración pública española',
    'operativa de gestorías y despachos'
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'soporte técnico',
    email: 'contacto@certy.es',
    availableLanguage: ['es']
  },
  areaServed: 'ES',
  slogan: 'Gestión profesional de certificados digitales en Windows'
};

export const certyWebsiteSchema = {
  '@type': 'WebSite',
  '@id': CERTY_WEBSITE_ID,
  url: `${CERTY_URL}/`,
  name: 'Certy',
  description: 'Software y recursos prácticos para gestionar certificados digitales.',
  inLanguage: 'es-ES',
  publisher: { '@id': CERTY_ORGANIZATION_ID }
};

export const certySoftwareSchema = {
  '@type': 'SoftwareApplication',
  '@id': CERTY_SOFTWARE_ID,
  name: 'Certy',
  url: `${CERTY_URL}/software-gestion-certificados-digitales`,
  downloadUrl: `${CERTY_URL}/downloads`,
  image: `${CERTY_URL}/certy-logo-512.png`,
  description:
    'Aplicación de escritorio para Windows que permite localizar certificados digitales instalados, comprobar su vigencia y abrir portales oficiales con una operativa más ordenada.',
  applicationCategory: 'BusinessApplication',
  applicationSubCategory: 'Gestión de certificados digitales',
  operatingSystem: 'Windows 10 o superior (64 bits)',
  inLanguage: 'es-ES',
  publisher: { '@id': CERTY_ORGANIZATION_ID },
  featureList: [
    'Búsqueda de certificados por titular',
    'Detección de certificados instalados en Windows',
    'Control visual de vigencia y caducidad',
    'Acceso organizado a portales oficiales',
    'Licencia por dispositivo'
  ],
  audience: {
    '@type': 'BusinessAudience',
    audienceType: 'Gestorías, asesorías, despachos profesionales y equipos administrativos'
  },
  offers: [
    {
      '@type': 'Offer',
      name: 'Plan mensual',
      price: '9.99',
      priceCurrency: 'EUR',
      url: `${CERTY_URL}/#pricing`,
      availability: 'https://schema.org/InStock'
    },
    {
      '@type': 'Offer',
      name: 'Plan anual',
      price: '99.99',
      priceCurrency: 'EUR',
      url: `${CERTY_URL}/#pricing`,
      availability: 'https://schema.org/InStock'
    }
  ]
};

export const certyEntityGraph = {
  '@context': 'https://schema.org',
  '@graph': [certyOrganizationSchema, certyWebsiteSchema, certySoftwareSchema]
};
